// @flow

// TODO this will be deprecated after https://github.com/catalyticlabs/pushbot-api/pull/6643

import api from '../../store/config/api';
import { CREDENTIAL as SCHEMA } from '../../schemas';

import type {
  Credential,
  DisplayName,
  Identifier,
  Secret,
  Urls
} from '../../Credential/CredentialType';

export const [
  GET_CREDENTIAL,
  GET_CREDENTIAL_REQUEST,
  GET_CREDENTIAL_SUCCESS,
  GET_CREDENTIAL_FAILURE
] = api.buildTypes('GET_CREDENTIAL');

export function getCredential({ teamName, credentialID }: Credential) {
  return {
    type: GET_CREDENTIAL,
    payload: {
      url: `/teams/${teamName}/credentials/${credentialID}`,
      schema: SCHEMA
    }
  };
}

export const [
  ADD_CREDENTIAL,
  ADD_CREDENTIAL_REQUEST,
  ADD_CREDENTIAL_SUCCESS,
  ADD_CREDENTIAL_FAILURE
] = api.buildTypes('ADD_CREDENTIAL');

export function addCredential({
  teamName,
  identifier,
  secret,
  displayName,
  urls,
  appName
}: Credential) {
  return {
    type: ADD_CREDENTIAL,
    payload: {
      url: `/teams/${teamName}/credentials`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: {
          teamName,
          identifier,
          secret,
          displayName,
          urls,
          appName
        }
      }
    }
  };
}

export const [
  UPDATE_CREDENTIAL,
  UPDATE_CREDENTIAL_REQUEST,
  UPDATE_CREDENTIAL_SUCCESS,
  UPDATE_CREDENTIAL_FAILURE
] = api.buildTypes('UPDATE_CREDENTIAL');

export function updateCredential({
  credentialID,
  teamName,
  identifier,
  secret,
  displayName,
  urls
}: Credential) {
  const body: {
    identifier: Identifier,
    displayName: DisplayName,
    urls: Urls,
    secret?: Secret
  } = {
    identifier,
    displayName,
    urls
  };

  if (secret) {
    body.secret = secret;
  }

  return {
    type: UPDATE_CREDENTIAL,
    payload: {
      url: `/teams/${teamName}/credentials/${credentialID}`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body
      }
    }
  };
}

export const [
  DELETE_CREDENTIAL,
  DELETE_CREDENTIAL_REQUEST,
  DELETE_CREDENTIAL_SUCCESS,
  DELETE_CREDENTIAL_FAILURE
] = api.buildTypes('DELETE_CREDENTIAL');

export function deleteCredential({ credentialID, teamName }: Credential) {
  return {
    type: DELETE_CREDENTIAL,
    payload: {
      url: `/teams/${teamName}/credentials/${credentialID}`,
      schema: SCHEMA,
      options: {
        method: 'DELETE'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/credential.js